/**
 * 将侧孔侧槽字符串逆时针旋转90°
 * @param {string} str - 输入字符串，例如 "1←2↓3→4↑" 或 "1↓2→" 或 "1←2↓3↑"
 * @returns {string} - 旋转后的字符串
 *
 * 处理步骤：
 * 1. 先按照逆时针90°旋转每个箭头：
 *    ← → ↓ (左边变成下边)
 *    ↓ → → (下边变成右边)
 *    → → ↑ (右边变成上边)
 *    ↑ → ← (上边变成左边)
 * 2. 然后按照标准顺序 ←↓→↑ 重新排序
 * 3. 最后数字从1开始重新编号
 *
 * 示例：
 * - "1↓2→" → 旋转后 "1→2↑" → 排序后 "1→2↑" → 重新编号 "1→2↑"
 * - "1←2↓3↑" → 旋转后 "1↓2→3←" → 排序后 "3←1↓2→" → 重新编号 "1←2↓3→"
 * - "1←2↓3→4↑" → 旋转后 "1↓2→3↑4←" → 排序后 "4←1↓2→3↑" → 重新编号 "1←2↓3→4↑"
 */
export function rotateSholeSslotStrCCW90(str) {
  if (!str || typeof str !== 'string' || str.includes('翻面')) {
    return str || ''
  }

  // 逆时针90°的映射关系
  const arrowMap = {
    '←': '↓', // 左 → 下
    '↓': '→', // 下 → 右
    '→': '↑', // 右 → 上
    '↑': '←', // 上 → 左
  }

  // 排序优先级：←↓→↑ 对应 1,2,3,4
  const sortOrder = {
    '←': 1,
    '↓': 2,
    '→': 3,
    '↑': 4,
  }

  // 使用正则表达式匹配 "数字+箭头" 的模式
  // 例如：匹配 "1←", "2↓", "3→" 等
  const pattern = /(\d+)([←↓→↑])/g
  const matches = []

  // 收集所有匹配项
  let match
  while ((match = pattern.exec(str)) !== null) {
    const number = match[1]
    const arrow = match[2]
    const newArrow = arrowMap[arrow]
    if (newArrow) {
      matches.push({
        number,
        arrow: newArrow,
        original: number + arrow,
      })
    }
  }

  // 按照 ←↓→↑ 的顺序排序
  matches.sort((a, b) => {
    return sortOrder[a.arrow] - sortOrder[b.arrow]
  })

  // 组合成最终字符串，数字从1开始重新编号
  const result = matches
    .map((item, index) => {
      return index + 1 + item.arrow
    })
    .join('')

  return result
}
